import { render, staticRenderFns } from "./RealTimeVideo.vue?vue&type=template&id=187bc76e&"
import script from "./RealTimeVideo.vue?vue&type=script&lang=js&"
export * from "./RealTimeVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports